import React, { useRef } from "react";
import { IFocusableFormField } from "@type";
import { IPasswordStrengthProps, PasswordStrength } from "../PasswordStrength";

export interface IFormPasswordStrengthProps<Values = Record<string, unknown>>
  extends IPasswordStrengthProps,
    IFocusableFormField<Values> {}

export const FormPasswordStrength: <Values = Record<string, unknown>>(
  props: IFormPasswordStrengthProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <PasswordStrength
      {...rest}
      {...parentForm.getInputProps(fieldName)}
      ref={elementRef}
    />
  );
};
